<template>
  <footer id="footer" class="footer">
        <div class="main-part">
            <div class="footer-list-wrapper">
                <h3 class="footer-heading">Teen Club</h3>
                <ul class="footer-list">
                    <li class="footer-list-item">
                        <a href="#" class="footer-list-link">
                            tctheteenclub@gmail.com
                        </a>
                    </li>
                    <li class="footer-list-item">
                        <a href="#" class="footer-list-link">
                            105, Atlantic Plaza, Garage Galli, Tulsi Pipe road<br>
                            near Tilak Bhavan, Dadar(W),<br>Mumbai-400028
                        </a>
                    </li>
                    <li class="footer-list-item">
                        <a href="#" class="footer-list-link">
                            Tel: 9967047111 / 9167131215
                        </a>
                    </li>
                </ul>
            </div>

            <div class="footer-list-wrapper">
                <h3 class="footer-heading">Explore</h3>
                <ul class="footer-list">
                    <li class="footer-list-item">
                        <a href="javascript:void(0);"
                        @click="HandleMenuNavigation('/','')"
                        class="footer-list-link">
                            Home
                        </a>
                    </li>
                    <li class="footer-list-item">
                        <a href="javascript:void(0);"
                        @click="HandleMenuNavigation('/','#about-us')"
                        class="footer-list-link">
                            About Us
                        </a>
                    </li>
                     <li class="footer-list-item">
                        <a href="javascript:void(0);"
                        @click="HandleMenuNavigation('/','#featured')"
                        class="footer-list-link">
                            Featured Products
                        </a>
                    </li>
                    <li class="footer-list-item">
                        <a href="javascript:void(0);"
                        @click="HandleMenuNavigation('/products','')"
                        class="footer-list-link">
                            Products
                        </a>
                    </li>
                </ul>
            </div>

            <div class="gallery">
                <h3 class="footer-heading">Gallery</h3>
                <div class="gallery-images">
                    <div class="image-wrapper">
                        <img src="../images/gallery/10988_ICE.webp" class="footer-image">
                    </div>
                    <div class="image-wrapper">
                        <img src="../images/gallery/10996_DENIMAX.webp" class="footer-image">
                    </div>
                    <div class="image-wrapper">
                        <img src="../images/gallery/11128_PISTA.webp" class="footer-image">
                    </div>
                    <div class="image-wrapper">
                        <img src="../images/gallery/11138_MUSTURD.webp" class="footer-image">
                    </div>
                    <div class="image-wrapper">
                        <img src="../images/gallery/11166_SEAGREEN.webp" class="footer-image">
                    </div>
                    <div class="image-wrapper">
                        <img src="../images/gallery/11179_DENIMAX.webp" class="footer-image">
                    </div>
                </div>
            </div>
        </div>

        <div class="creator-part">
            <div class="copyright-text">
                <p>Copyright &copy; 2020. Teen Club. All Rights Reserved</p>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'WebsiteFooter',
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    HandleMenuNavigation(path, anchor) {
      this.$ga.event({
        eventCategory: 'Footer Navigation',
        eventAction: 'Menu clicked',
        eventLabel: path + anchor,
      });
      const route = path + anchor;
      if ((path === '' || path === this.$route.path) && anchor !== '') {
        // eslint-disable-next-line no-restricted-globals
        location.href = route;
      } else if (path === this.$route.path) {
        this.scrollToTop();
      } else {
        this.$router.push(route);
      }
    },
  },
};
</script>
